import $ from 'jquery';

export default () => {
    const slider = $('.js-awards-slider');

    if (slider.is('*')) {
        slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            adaptiveHeight: true,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 900,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        prevArrow: $('.js-award-arrow-prev'),
                        nextArrow: $('.js-award-arrow-next'),
                    }
                },
            ],
        });
    }
}



// WEBPACK FOOTER //
// ../src/scripts/modules/awards.js